(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projecten-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vbm-project-gallery')) {
    customElements.define('vbm-project-gallery', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.viewport || !this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.dialog = this.querySelector('dialog');
        this.index = 0;

        if (this.slides.length > 1) {
          this.querySelector('[data-controls]').hidden = false;
          this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
          this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
          this.viewport.addEventListener('scroll', () => {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.update());
          }, { ...options, passive: true });
          this.viewport.addEventListener('keydown', (event) => {
            if (event.target !== this.viewport) return;
            const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
            if (!(event.key in destinations)) return;
            event.preventDefault();
            this.goTo(destinations[event.key]);
          }, options);
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: 'instant' });
            });
            this.resizeObserver.observe(this.viewport);
          }
          this.update();
        }

        if (this.dialog && typeof this.dialog.showModal === 'function') {
          this.querySelectorAll('[data-enlarge]').forEach((link) => {
            link.addEventListener('click', (event) => {
              if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
              event.preventDefault();
              const original = link.querySelector('img');
              const enlarged = this.dialog.querySelector('img');
              enlarged.src = link.href;
              enlarged.alt = original.alt;
              this.dialog.querySelector('[data-caption]').textContent = link.dataset.caption;
              this.opener = link;
              this.dialog.showModal();
            }, options);
          });
          this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => {
            if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          }, options);
        }
      }

      goTo(index) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({ left: destination * this.viewport.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
      }

      update() {
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / (this.viewport.clientWidth || 1))));
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        const message = `Foto ${this.index + 1} van ${this.slides.length} · ${this.slides[this.index].dataset.phase}`;
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
